import { Box, KdsText, VStack } from "@kazaar-platform/design-system";
import { useTranslate } from "@tolgee/react";
import dayjs from "dayjs";
import { type DesiredDeliveryDateBlocProps } from "./DesiredDeliveryDateBloc.types";

export const DesiredDeliveryDateBloc = ({
  deliveryDate,
}: DesiredDeliveryDateBlocProps) => {
  const { t } = useTranslate();

  return (
    <Box rounded="br-sm" bgColor="elevation.first" p="sp-md" w="100%">
      <VStack gap="sp-xs">
        <KdsText as="h2" size="title-sm">
          {t("orderItemSummary.desiredDeliveryDate.title")}
        </KdsText>

        <KdsText size="subtitle-md">{dayjs(deliveryDate).format("L")}</KdsText>
      </VStack>
    </Box>
  );
};
